var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3011_26986)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.2937,
    cy: 6.99305,
    rx: 19.4533,
    ry: 19.5631,
    transform: "rotate(45 11.2937 6.99305)",
    fill: "url(#paint0_radial_3011_26986)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.96,
    cy: 15.0706,
    rx: 28.4373,
    ry: 10.3597,
    transform: "rotate(-59.902 15.96 15.0706)",
    fill: "url(#paint1_radial_3011_26986)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3011_26986",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.2122 5.30987) rotate(-104.953) scale(15.5068 15.4314)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#00F956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F956",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3011_26986",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8409 14.1793) rotate(-126.4) scale(9.85668 18.7932)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#7A55D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#7A55D7",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#7A55D7",
    stopOpacity: 0.167143
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#7A55D7",
    stopOpacity: 0.0911688
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A55D7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3011_26986"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedImg);
export default __webpack_public_path__ + "static/media/verifiedImg.8a805be249edb39d3e8610ac90b0d9e1.svg";
export { ForwardRef as ReactComponent };